module.exports = __webpack_public_path__ + "static/media/TN-Men-Shirts-v2.0.490286df.svg";